import { render, staticRenderFns } from "./switchNfcDialog.vue?vue&type=template&id=9bca0f2a&"
import script from "./switchNfcDialog.vue?vue&type=script&lang=js&"
export * from "./switchNfcDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchNfcDialog.vue?vue&type=style&index=0&id=9bca0f2a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports